import React, { useState, useEffect } from 'react';
import SideNavbar from './SideNavbar';
import DeveloperCredit from './common/DeveloperCredit';
import { useTranslation } from 'react-i18next';

/**
 * App Layout Component
 * Provides consistent layout with side navigation for all pages
 */
const AppLayout = ({ children, pageTitle, currentPage = 'dashboard', setCurrentPage }) => {
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const effectiveTitle = pageTitle ?? t('navigation.pages.dashboard');

  // Update the document title whenever the pageTitle changes
  /**
   * Effect: update browser document.title when `pageTitle` changes.
   * Wrapped in try/catch to be safe in non-browser environments (SSR/test runners).
   */
  useEffect(() => {
    const base = t('navigation.appName');
    try {
      document.title = effectiveTitle ? `${effectiveTitle} - ${base}` : base;
    } catch (e) {
      // safe guard for non-browser environments
      // no-op
    }
  }, [effectiveTitle, t]);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Side Navigation */}
      <SideNavbar 
        isMobileMenuOpen={isMobileMenuOpen} 
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
      
      {/* Main Content Area */}
      <div className="flex flex-1 flex-col overflow-hidden w-full">
        {/* Page Content */}
        {/* Add top padding on small screens to account for the mobile top navbar height (approx 56px) */}
        <div className="flex-1 overflow-y-auto overflow-x-hidden hide-scrollbar pt-14 xl:pt-0 w-full">
          {children}
        </div>
        
        {/* Developer Credit - only visible on desktop, hidden on mobile where it shows in sidebar */}
        <div className="hidden xl:block">
          <DeveloperCredit variant="footer" />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;